<div class="kbback" (click)="closed.emit()"></div>
<div class="kbdlg" role="dialog" appDialogFocus [attr.aria-label]="S['Keyboard shortcuts']" (keydown.escape)="closed.emit()">
  <header class="kbdlg__head">
    <h2 class="kbdlg__title">{{ S['Keyboard shortcuts'] }}</h2>
    <button class="iconbtn iconbtn--bare" [title]="S['Close']" (click)="closed.emit()" [attr.aria-label]="S['Close']">
      <app-icon name="close" size="16" />
    </button>
  </header>
  <dl class="kbdlg__list">
    @for (s of shortcuts; track s.label) {
      <div class="kbdlg__row">
        <dt>{{ s.label }}</dt>
        <dd><kbd>{{ s.keys }}</kbd></dd>
      </div>
    }
  </dl>
</div>
  
